import { HttpErrorResponse } from '@angular/common/http';
import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { catchError, Observable, tap, throwError } from 'rxjs';

export interface RequestTrackingState {
  loading: boolean;
  error: HttpErrorResponse | null;
}

export function withRequestTracking() {
  return signalStoreFeature(
    { state: type<RequestTrackingState>() },
    withMethods(store => ({
      trackRequest<T>(request$: Observable<T>): Observable<T> {
        patchState(store, { loading: true });
        return request$.pipe(
          tap(() => patchState(store, { loading: false, error: null })),
          catchError((error: HttpErrorResponse) => {
            patchState(store, { error, loading: false });
            return throwError(() => error);
          }),
        );
      },
    })),
  );
}
